import React from "react";
import PropTypes from "prop-types";
import MDBox from "shared/ui/Box/MDBox";
import EditIcon from "@mui/icons-material/Edit";
import { alpha } from "@mui/material/styles";

export default function EditModeButton({ onClick }) {
  return (
    <MDBox
      onClick={onClick}
      sx={{
        width: "100%",
        px: 2,
        py: 0.9, // 👈 más fino en altura
        borderRadius: "999px",
        cursor: "pointer",
        userSelect: "none",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",

        fontSize: "0.78rem", // 👈 tipografía más ligera
        fontWeight: 600,
        letterSpacing: "0.01em",

        border: "1.5px solid",
        borderColor: "primary.main",
        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
        color: "primary.main",

        transition: "all 0.18s ease",
        "&:hover": {
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.14),
        },
        "&:active": {
          transform: "scale(0.985)",
        },
      }}
    >
      <EditIcon sx={{ fontSize: 16 }} />
      Editar varios ejercicios
    </MDBox>
  );
}

EditModeButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
